export enum ContratoControleQualidadeStatus {
  PENDENTE = 'pendente',
  EM_ANALISE = 'em_analise',
  APROVADO = 'aprovado',
  REPROVADO = 'reprovado',
  FINALIZADO = 'finalizado'
}

export interface ContratoControleQualidade {
  id: number;
  contrato_id: number;
  status: ContratoControleQualidadeStatus;
  observacoes?: string;
  motivo_reprovacao?: string;
  checklist?: Record<string, boolean>;
  data_inicio_analise?: string;
  data_fim_analise?: string;
  responsavel_id: number;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  contrato?: {
    id: number;
    contrato_numero?: string;
    cliente?: {
      id: number;
      nome: string;
      cpf: string;
    };
    consultor?: {
      id: number;
      nome: string;
    };
  };
  responsavel?: {
    id: number;
    nome: string;
    email: string;
  };
}

export interface CreateContratoControleQualidadeDto {
  contrato_id: number;
  tenant_id?: number;
  observacoes?: string;
  checklist?: Record<string, boolean>;
}

export interface UpdateContratoControleQualidadeDto {
  status?: ContratoControleQualidadeStatus;
  observacoes?: string;
  motivo_reprovacao?: string;
  checklist?: Record<string, boolean>;
  data_inicio_analise?: string;
  data_fim_analise?: string;
}

export interface IniciarControleQualidadeDto {
  responsavel_id: number;
  observacoes?: string;
}

export interface FinalizarControleQualidadeDto {
  status: ContratoControleQualidadeStatus;
  observacoes?: string;
  motivo_reprovacao?: string;
  checklist?: Record<string, boolean>;
}

export interface ContratoControleQualidadeFilters {
  status?: ContratoControleQualidadeStatus;
  responsavel_id?: number;
  contrato_id?: number;
  data_inicio?: string;
  data_fim?: string;
} 